import { render, staticRenderFns } from "./AuthDataConfig.vue?vue&type=template&id=124e5b2a&"
import script from "./AuthDataConfig.vue?vue&type=script&lang=js&"
export * from "./AuthDataConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports